import * as React from 'react';
const CloseIconSmall = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_1908_6123"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1908_6123)">
      <path
        d="M9.99995 10.8861L7.2948 13.5912C7.17408 13.712 7.02771 13.771 6.8557 13.7683C6.6837 13.7656 6.53734 13.704 6.41662 13.5832C6.29589 13.4625 6.23553 13.3148 6.23553 13.1401C6.23553 12.9655 6.29589 12.8178 6.41662 12.697L9.11376 9.9999L6.4086 7.31558C6.28787 7.19486 6.22885 7.04716 6.23153 6.87248C6.2342 6.6978 6.29589 6.5501 6.41662 6.42937C6.53734 6.30865 6.68504 6.24829 6.85972 6.24829C7.03439 6.24829 7.18208 6.30865 7.3028 6.42937L9.99995 9.13454L12.6843 6.42937C12.805 6.30865 12.9514 6.24829 13.1234 6.24829C13.2954 6.24829 13.4417 6.30865 13.5624 6.42937C13.6917 6.55865 13.7563 6.70849 13.7563 6.8789C13.7563 7.0493 13.6917 7.19486 13.5624 7.31558L10.8653 9.9999L13.5705 12.705C13.6912 12.8258 13.7516 12.9721 13.7516 13.1441C13.7516 13.3161 13.6912 13.4625 13.5705 13.5832C13.4412 13.7125 13.2914 13.7771 13.1209 13.7771C12.9505 13.7771 12.805 13.7125 12.6843 13.5832L9.99995 10.8861Z"
        fill="#1A1A1A"
      />
    </g>
  </svg>
);
export default CloseIconSmall;
